// 平台
export const PLATFORM = {
  all: '',
  pc: 'pc',
  mobile: 'mobile',
  ios: 'ios',
  android: 'android',
  web: 'web',
  mac: 'mac',
  // web工作台独有（客服电商url跳转涉及）
  WEBB: 'webb',
};

// 样式属性
export const STYLE_ATTRS = [
  'width',
  'height',
  'gravity',
  'weight',
  'padding',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'margin',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'aspectRatio',
  'background',
  'backgroundIcon',
  'alpha',
  'cornerRadius',
  'borderWidth',
  'borderColor',
  'borderStyle',
  'hidden',
];

// 动作属性
export const ACTION_ATTRS = ['click', 'change', 'blur', 'focus', 'action', 'actionData'];

// 动作类型
export const ACTION_LIST = ['callJS', 'browser'];

// 映射flex属性
export const FLEX_MAP = {
  H: {
    left: 'flex-start',
    right: 'flex-end',
    centerHorizontal: 'center',
  },
  V: {
    top: 'flex-start',
    bottom: 'flex-end',
    centerVertical: 'center',
  },
};

// 16进制转10进制
export const HEX_MAP = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  a: 10,
  b: 11,
  c: 12,
  d: 13,
  e: 14,
  f: 15,
};
